import {
  SET_FEATURED_PRODUCTS,
  SET_TOP_PRODUCTS,
  SET_TRENDING_PRODUCTS,
} from '../constants/action-types'
// import { findIndex } from "../utils";

import { persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'

const initialState = {
  featuredProducts: [],
  topProducts: [],
  trendingProducts: [],
}

const homepageReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_TOP_PRODUCTS:
      return { ...state, topProducts: action.products }
    case SET_FEATURED_PRODUCTS:
      return { ...state, featuredProducts: action.products }
    case SET_TRENDING_PRODUCTS:
      return { ...state, trendingProducts: action.data }
    default:
      return state
  }
}
const persistConfig = {
  keyPrefix: 'happymall-',
  key: 'homepage',
  storage,
}

export default persistReducer(persistConfig, homepageReducer)
